import Footer from 'components/InfoFooter';
import React from 'react';
import useConfig from 'hooks/useConfig';
import { Button } from '@mui/material';
import { StyledBody, StyledError } from './styles';

/** Error fallback UI component */

function InternalServerErrorPage() {
  const orgName = useConfig('general.name');
  return (
    <div>
      <StyledError>
        <StyledBody>
          <p className="error">500</p>
          <p className="error-title">Oops!! Internal server error</p>
          <p className="c-text">
            <strong className="site">{orgName}</strong>
            {' '}
            is
            currently unable to handle this requast.
          </p>
          <div className="btns">
            <a rel="noopener noreferrer" href="/">
              <Button>
                Home page
              </Button>
            </a>
          </div>
        </StyledBody>
        <Footer />
      </StyledError>
    </div>
  );
}

export default InternalServerErrorPage;
